import React, {ComponentType} from "react";
import SectionsMaxOccupancy from "./index";
import {IProps, IContainerProps, IServices, IHandlers} from './types';

/**
 * Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
 */
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
import {ISectionOrder} from "app/types/client.types";

const NS = 'SectionsMaxOccupancyContainer';
export const classPrefix = 'SectionsMaxOccupancy';

const propsKeys: string[] = keys<IProps>();
const containerPropsKeys: string[] = keys<IContainerProps>();
const handlersKeys: string[] = keys<IHandlers>();
const servicesKeys: string[] = keys<IServices>();

const ThemeWrap = function (all: IProps & IContainerProps & IHandlers & IServices) {

  /**
   * Sorts 'all' into IServices, IProps and IContainerProps
   */
  const {}: IServices = ReactUtilsService.getObjectByKeys(all, servicesKeys) as IServices;
  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  const {sectionName, sectionIndex, maxOccupancy, sections, enableMaxOccupancy, changeSectionName, changeMaxOccupancy, moveUp, moveDown}: IContainerProps = ReactUtilsService.getObjectByKeys(all, containerPropsKeys) as IContainerProps;
  props.sectionName = sectionName;
  props.sectionIndex = sectionIndex;
  props.maxOccupancy = maxOccupancy;
  props.sections = sections;
  props.enableMaxOccupancy = enableMaxOccupancy;
  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
  const handlers: IHandlers = {
    changeSectionName: (sectionName) => {
      changeSectionName(sectionName, sectionIndex);
    },

    changeMaxOccupancy: (maxOccupancy) => {
      changeMaxOccupancy(maxOccupancy, sectionIndex);
    },

    moveUp: (sectionIndex: number, section: ISectionOrder) => {
      moveUp(sectionIndex, section);
    },

    moveDown: (sectionIndex: number, section: ISectionOrder) => {
      moveDown(sectionIndex, section);
    }

  }

  return ReactUtilsService.containerWrap(
    <SectionsMaxOccupancy {...props} {...handlers} />, classPrefix
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2ASectionsMaxOccupancy: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
  servicesKeys
];
